<div class="hc-radio-group" [class.hc-radio-group--inline]="inline" [class.hc-radio-group--stacked]="!inline"
     [class.hc-radio-group--error]="hasError" role="radiogroup">
  @for (option of options; track option.value) {
    <label class="hc-radio" [class.hc-radio--checked]="option.value === value"
           [class.hc-radio--disabled]="disabled || option.disabled">

      <!-- Hidden native input — makes clicking the label text work -->
      <input
        type="radio"
        [name]="name"
        [value]="option.value"
        [checked]="option.value === value"
        [disabled]="disabled || option.disabled"
        (change)="select(option)"
        tabindex="-1"
        aria-hidden="true"
        class="hc-radio__native-input" />

      <span class="hc-radio__circle" tabindex="0" role="radio"
            [attr.aria-checked]="option.value === value"
            [attr.aria-disabled]="disabled || option.disabled || null"
            (click)="select(option)"
            (keydown)="onKeydown($event, option)">
        @if (option.value === value) {
          <span class="hc-radio__dot"></span>
        }
      </span>
      <span class="hc-radio__label">{{ option.label }}</span>
    </label>
  }
</div>
